module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.dd65cd2b.svg";